import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Shield } from 'lucide-react';
import { useLanguage } from './Localization';

const Footer = () => {
  const { t, language } = useLanguage(); // Get translation function and current language
  const currentYear = new Date().getFullYear();

  // Determine privacy policy URL based on language
  const privacyPolicyUrl = language === 'fr' ? '/privacy-fr.html' : '/privacy.html';

  return (
    <footer id="footer" className="relative bg-gray-900 text-white scroll-mt-24">
      {/* Top accent line */}
      <div className="h-1 w-full bg-gradient-to-r from-brand-500 via-emerald-400 to-teal-500" />

      <div className="container mx-auto px-4 py-14">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-10 items-start text-center md:text-left"
        >
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start gap-4">
            <img
              src="/assets/img/logo/logo_site.png"
              alt={t('altText')}
              className="h-16"
            />
            <p className="text-sm text-white/60 max-w-xs">
              {t('copyright', { year: currentYear })}
            </p>
          </div>

          {/* Privacy Policy */}
          <div className="flex flex-col items-center md:items-start gap-3">
            <h4 className="font-display text-lg font-semibold text-white/90">
              {t('privacyPolicy')}
            </h4>
            <a
              href={privacyPolicyUrl}
              className="inline-flex items-center gap-2 text-white/70 hover:text-brand-300 transition-colors duration-200"
            >
              <Shield className="w-4 h-4" />
              {t('privacyPolicy')}
            </a>
          </div>

          {/* Contact */}
          <div className="flex flex-col items-center md:items-start gap-3">
            <h4 className="font-display text-lg font-semibold text-white/90">
              {t('contactLabel')}
            </h4>
            <a
              href="mailto:hello@summit-games.com"
              className="inline-flex items-center gap-2 text-white/70 hover:text-brand-300 transition-colors duration-200 break-all"
            >
              <Mail className="w-4 h-4 flex-shrink-0" />
              hello@summit-games.com
            </a>
          </div>
        </motion.div>

        <div className="mt-12 pt-6 border-t border-white/10 text-center text-xs text-white/40">
          {t('copyright', { year: currentYear })}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
